import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import { Radio } from 'semantic-ui-react';
import { EyeIcon, HiddenEyeIcon } from '../../../../components/icons';
import ChangePasswordModal from '../../AccountSettings/ChangePasswordModal';
import { useUserContext } from '../../../../context/UserContext';

const Input = styled.input`
  background: #f7f7f9;
  border: 1px solid #e5e5ea;
  border-radius: 5px;
  height: 48px;
  width: 487px;
  :focus {
    outline: none;
  }
`;
interface IProps {
  companyFTPSetting: FtpSetting;
  changeFtpValue: (label: keyof FtpSetting, value: any) => void;
  handleAfterChange: () => void;
  allowFtpChange: boolean
}

export default function FtpForm(props: IProps) {
  const [openPasswordModal, setOpenPasswordModal] = useState(false);
  const { user } = useUserContext();
  return (
    <div>
      <div style={{ display: 'flex', marginTop: 24, alignItems: 'center' }}>
        <div style={{ width: 130 }}>Host</div>{' '}
        <Input
          onChange={e => props.changeFtpValue('host', e.target.value)}
          value={props.companyFTPSetting?.host}
          placeholder="Enter the host name"
        />
      </div>
      <div style={{ display: 'flex', marginTop: 24, alignItems: 'center' }}>
        <div style={{ width: 130 }}>Username</div>{' '}
        <Input
          onChange={e => props.changeFtpValue('username', e.target.value)}
          value={props.companyFTPSetting?.username}
          placeholder="Enter your username"
        />
      </div>
      <div style={{ display: 'flex', marginTop: 24, alignItems: 'center', position:'relative' }}>
        <div style={{ width: 130 }}>Password</div>{' '}
        <Input
          onChange={e => props.allowFtpChange && props.changeFtpValue('password', e.target.value)}
          value={props.companyFTPSetting?.password}
          placeholder="Enter your password"
          
          type={'password'}
          style={{
            background: '#f7f7f9',
            border: '1px solid #e5e5ea',
            borderRadius: 5,
            height: 48,
            width: 487,
          }}
        />

      </div>
      {(props.companyFTPSetting.password && !props.allowFtpChange) && <div
          style={{
            fontSize: 12,
            color: '#8e8e93',
            display: 'flex',
            justifyContent: 'flex-end',
            cursor: 'pointer',
          }}
          onClick={() => setOpenPasswordModal(true)}
        >
          Change Password
        </div>}
      {openPasswordModal && (
        <ChangePasswordModal
          open={openPasswordModal}
          onClose={() => setOpenPasswordModal(false)}
          userId={user.id}
          changePasswordUrl={'/api/clientaccount/ChangeFTPPassword'}
          confirmPasswordUrl={'/api/clientaccount/MatchFTPPassword'}
          needsClientId
          handleAfterChange={props.handleAfterChange}
        />
      )}
    </div>
  );
}
